module.exports = [
  {
    name: "Red Dot",
    id: 0,
  },
  {
    name: "Green Dot",
    id: 1,
  },
  {
    name: "Pyramid",
    id: 2,
  },
  {
    name: "Tau",
    id: 3,
  },
  {
    name: "Ray",
    id: 4,
  },
  {
    name: "Spread",
    id: 5,
  },
  {
    name: "Marine",
    id: 6,
  },
  {
    name: "Underline",
    id: 7,
  },
  {
    name: "Precision",
    id: 8,
  },
  {
    name: "Quantum",
    id: 9,
  },
  {
    name: "Triad",
    id: 10,
  },
  {
    name: "Nuclear",
    id: 11,
  },
];
